<template>
    <g>
<g stroke-width="2.00" fill="none" stroke-linecap="butt">
<path stroke="#87a739" vector-effect="non-scaling-stroke" d="
  M 101.98 14.93
  Q 89.69 17.06 87.36 29.87"
/>
<path :style="{fill: $attrs.fgColor}" stroke="#c41f2a" vector-effect="non-scaling-stroke" d="
  M 78.78 24.19
  Q 59.99 11.86 37.99 17.39
  Q 26.74 20.23 16.56 26.91"
/>
<path :style="{fill: $attrs.fgColor}" stroke="#c41f2a" vector-effect="non-scaling-stroke" d="
  M 32.58 115.06
  L 30.42 118.32"
/>
</g>
<path fill="#6e8137" d="
  M 101.98 14.93
  Q 89.69 17.06 87.36 29.87
  Q 82.49 24.14 82.91 18.25
  C 83.60 8.34 90.01 2.88 99.24 0.93
  A 1.08 1.07 -24.4 0 1 100.32 1.33
  Q 101.88 3.36 102.14 4.99
  Q 102.78 8.96 101.98 14.93
  Z"
/>
<path :style="{fill: $attrs.fgColor}" fill="#da1f2c" d="
  M 78.78 24.19
  Q 59.99 11.86 37.99 17.39
  Q 26.74 20.23 16.56 26.91
  Q 22.36 19.52 29.54 14.80
  Q 54.57 -1.63 83.51 6.88
  Q 83.89 6.99 83.68 7.32
  Q 78.50 15.58 81.56 24.50
  Q 82.13 26.16 80.63 25.27
  L 78.78 24.19
  Z"
/>
<path fill="#9fcc3a" d="
  M 87.36 29.87
  Q 89.69 17.06 101.98 14.93
  Q 107.29 14.32 112.51 14.74
  Q 115.08 14.94 116.80 16.85
  Q 117.14 17.24 117.13 17.76
  Q 116.82 28.08 108.77 33.13
  Q 103.97 36.14 97.86 35.43
  Q 91.64 34.71 87.36 29.87
  Z"
/>
<path :style="{fill: $attrs.fgColor}" fill="#ae1f27" d="
  M 78.78 24.19
  Q 66.38 20.56 55.50 22.91
  C 40.14 26.23 27.66 37.19 22.66 52.16
  C 17.65 67.14 20.77 82.35 30.72 94.97
  Q 31.89 96.46 32.70 98.18
  Q 36.43 106.04 32.58 115.06
  L 30.42 118.32
  Q 10.90 105.27 4.74 82.33
  Q 3.51 77.79 2.52 72.06
  Q 1.59 66.77 2.20 62.77
  Q 2.91 58.08 4.30 52.01
  Q 7.66 37.42 16.56 26.91
  Q 26.74 20.23 37.99 17.39
  Q 59.99 11.86 78.78 24.19
  Z"
/>
<path :style="{fill: $attrs.fgColor}" fill="#da1f2c" d="
  M 30.42 118.32
  L 32.58 115.06
  Q 38.51 108.50 46.39 108.23
  Q 49.50 108.13 54.00 109.27
  C 82.97 116.66 111.03 92.85 108.40 62.44
  Q 107.24 49.06 98.53 38.21
  A 0.39 0.38 -16.7 0 1 98.87 37.59
  Q 108.52 38.32 114.80 30.87
  Q 115.22 30.37 115.59 30.91
  C 122.27 40.62 125.18 51.14 126.74 62.75
  C 127.56 68.83 126.02 74.83 124.76 80.69
  C 119.72 104.06 100.79 121.89 77.47 127.06
  Q 72.70 128.13 67.90 128.74
  Q 63.66 129.29 59.77 128.58
  Q 55.61 127.82 50.79 126.79
  Q 39.89 124.46 30.42 118.32
  Z"
/>
</g>
</template>

<script>
export default {
  name: "svgTorob"
}
</script>